import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import Navigation from '@/sections/Navigation';
import Footer from '@/sections/Footer';

const Industries = () => {
  const navigate = useNavigate();

  const industries = [
    { name: 'Logistics', description: 'Streamline supply chain operations with real-time tracking and data integration' },
    { name: 'Test and Balance', description: 'Automate testing processes and balance reporting for HVAC systems' },
    { name: 'Maintenance', description: 'Predictive maintenance solutions and facility management platforms' },
    { name: 'Finance', description: 'Secure financial data processing and portfolio management systems' },
    { name: 'Real Estate', description: 'Property management platforms with automated reporting and tenant portals' },
    { name: 'Plumbing', description: 'Service tracking and scheduling systems for plumbing operations' },
    { name: 'Accounting', description: 'Client portals with document management and financial reporting tools' },
    { name: 'Sporting', description: 'Community platforms and data analytics for sports organizations' },
    { name: 'Technology', description: 'Infrastructure solutions for tech companies and SaaS platforms' },
    { name: 'Food Franchises', description: 'Operations management and data insights for restaurant chains' },
    { name: 'Cartography', description: 'Mapping solutions and geographic data visualization tools' },
  ];

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <Navigation />
      <main className="flex-1 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-24 pb-16">
        {/* Back Button */}
        <button
          onClick={() => navigate('/')}
          className="flex items-center gap-2 text-slate-600 hover:text-slate-900 mb-12 transition-colors text-sm"
        >
          <ArrowLeft className="w-4 h-4" />
          <span>Back to Home</span>
        </button>

        {/* Header */}
        <div className="mb-16">
          <div className="inline-block mb-6">
            <span className="text-xs font-semibold text-kmg-primary uppercase tracking-wider px-3 py-1.5 bg-kmg-primary/10 rounded-full">
              Industries
            </span>
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
            Industries We Serve
          </h1>
          <p className="text-lg text-slate-600 max-w-3xl">
            The KMG Vectoral System powers businesses across diverse industries, 
            providing tailored data infrastructure solutions for each sector's unique needs.
          </p>
        </div>

        {/* Industries Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {industries.map((industry) => (
            <div
              key={industry.name}
              className={`group p-6 bg-white border-2 border-slate-200 rounded-2xl hover:border-kmg-primary hover:shadow-lg transition-all duration-300 hover:scale-[1.02] ${
                industry.name === 'Cartography' ? 'opacity-60' : ''
              }`}
            >
              <h3 className="text-xl font-bold text-slate-900 mb-3 group-hover:text-kmg-primary transition-colors">
                {industry.name}
              </h3>
              <p className="text-sm text-slate-600 leading-relaxed">
                {industry.description}
              </p>
            </div>
          ))}
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Industries;
